export const VALID = 'VALID';
export const NOT_VALID = 'NOT_VALID';
export const NOT_FOCUSED = 'NOT_FOCUSED';
